import React from "react";
import "./Destination.css";
import axios from "axios";
import { Link } from "react-router-dom";
import Preloader from "./Preloader";

class Destination extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      destinations: [],
      loading: true,
    };
  }

  componentDidMount() {
    axios.get(`https://api-gm.faisalhakim.com/`).then((res) => {
      const destinations = res.data.data;
      this.setState({
        destinations: destinations,
      });
      setTimeout(
        () =>
          this.setState({
            loading: false,
          }),
        500
      );
    });
  }

  render() {
    return (
      <>
        <div className="destination jumbotron-fluid">
          <h1>Destinasi</h1>
          <hr></hr>
          <div className="container">
            <div className="row m-auto">
              {this.state.destinations !== undefined ? (
                Object.values(this.state.destinations).map((destinations, index) => (
                  <div className="col-lg-3 col-md-6 dest" key={index}>
                    <div className="flip-card m-auto rounded">
                      <div className="flip-card-inner">
                        <div className="flip-card-front rounded">
                          <div className="position-relative">
                            <img
                              src={"https://garutmenawan.faisalhakim.com/zimages/" + destinations.filename}
                              className="destImage img-fluid rounded shadow"
                              alt=""
                            />
                            <div className="middle">
                              <div className="text">{destinations.name}</div>
                            </div>
                            <small>Foto : {destinations.source}</small>
                          </div>
                        </div>
                        <div className="flip-card-back rounded">
                          <div className="textBack">
                            <h5 className="text-center">{destinations.name}</h5>
                            <p className="text-center">
                              <span className="font-weight-bold">Lokasi</span> : <br />
                              {destinations.address}
                            </p>
                            <p className="text-center">
                              <span className="font-weight-bold">Tiket Masuk</span> : <br />
                              {destinations.ticket}
                            </p>
                            <Link to={"/detail?id=" + destinations.id}>
                              <p className="text-center">
                                <span className="font-weight-bold small">
                                  Lihat Detail <i className="fa fa-arrow-right" aria-hidden="true"></i>
                                </span>
                              </p>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div class="spinner-border text-secondary m-auto" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
              )}
            </div>
          </div>
        </div>
        <Preloader loading={this.state.loading} />
      </>
    );
  }
}

export default Destination;
